import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { PRODUCTION_PHOTO } from "@/lib/data";

export default function Reel({ embedUrl }) {
    const [playing, setPlaying] = useState(false);
    return (
        <section
            id="reel"
            data-testid="reel-section"
            className="bg-[#EBE9E4] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex items-end justify-between flex-wrap gap-6 mb-10 md:mb-14">
                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                    >
                        <p className="eyebrow">§ 02</p>
                        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-3 leading-[0.95] text-[#1A1A1A]">
                            Acting <span className="italic">Reel</span>
                        </h2>
                    </motion.div>
                    <p className="text-sm text-[#4A4A4A] max-w-sm">
                        A curated selection of recent on-camera and stage work.
                    </p>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="aspect-video w-full relative overflow-hidden bg-[#1A1A1A] border border-[#1A1A1A]"
                >
                    {playing && embedUrl ? (
                        <iframe
                            src={embedUrl}
                            title="Acting Reel — Vickie Daignault"
                            className="absolute inset-0 w-full h-full"
                            allow="autoplay; fullscreen"
                            allowFullScreen
                        />
                    ) : (
                        <button
                            onClick={() => embedUrl && setPlaying(true)}
                            data-testid="reel-play-button"
                            className="group absolute inset-0 w-full h-full"
                            aria-label="Play acting reel"
                        >
                            <img
                                src={PRODUCTION_PHOTO}
                                alt=""
                                className="w-full h-full object-cover opacity-40 group-hover:opacity-50 transition-opacity duration-500"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
                                <span className="w-20 h-20 md:w-24 md:h-24 rounded-full border border-[#F7F5F0]/80 flex items-center justify-center group-hover:border-[#C67C4E] group-hover:scale-110 transition-all duration-500">
                                    <Play
                                        size={26}
                                        className="text-[#F7F5F0] ml-1.5"
                                        fill="currentColor"
                                    />
                                </span>
                                <span className="eyebrow text-[#F7F5F0]/80 mt-2">
                                    Watch the Reel
                                </span>
                                {!embedUrl && (
                                    <span className="text-xs text-[#F7F5F0]/40 tracking-wider">
                                        Reel coming soon
                                    </span>
                                )}
                            </div>
                        </button>
                    )}
                </motion.div>
            </div>
        </section>
    );
}
